import cn from 'classnames'
import { memo } from 'react'

import { CustomTooltip } from 'shared/components/customTooltip/CustomTooltip'

import styles from './ActionIcon.module.scss'

type Props = {
  id?: string
  href?: string
  onClick?: () => void
  text: string
  iconClassName: string
  isActive?: boolean
  isVisible?: boolean
}

export const ActionIcon = memo<Props>(
  ({ id, isVisible = true, isActive = true, href, onClick, iconClassName, text }) => (
    <a
      className={cn(styles.actionIcon, {
        [styles.active]: isActive,
        [styles.unmounted]: !isVisible,
      })}
      id={id}
      href={href || undefined}
      onClick={isActive ? onClick : undefined}
      target="_blank"
      rel="noopener noreferrer"
    >
      <CustomTooltip text={text}>
        <i className={iconClassName} />
      </CustomTooltip>
    </a>
  )
)
